export default {
  default: {
    officeAdmin: 'Office Administrator',
    owner: 'Owner',
    user: 'User',
    recovered: 'Recovered',
    userRemoved: 'User Removed',
  },
}
